import React from 'react';
import { FormattedMessage } from 'react-intl';
import withSelection from '../../../reusable/LightTable/hoc/Selectable';
import withInfiniteScroll from '../../../reusable/LightTable/hoc/Scrollable';
import withSort from '../../../reusable/LightTable/hoc/Sortable';
import { USERS_DEFAULT_SORT, USERS_PAGE_SIZE } from '../../../constants';
import { withPermission } from '../../../context';
import LightTable from '../../../reusable/LightTable/VeryLightTable';
import withSearch from '../../../reusable/LightTable/hoc/Searchable';
import TableCoreComponent from '../../../reusable/LightTable/TableCoreComponent';
import PropTypes from 'prop-types';
import usersApi from '../../../api/Users.api';
import { compose } from 'redux';
import { ActiveLabel, TextCell } from '../../../reusable/LightTable/Components';
import { sortBy } from 'lodash';

const Table = compose(
    withPermission,
    withSelection,
    withSort,
    withSearch,
    withInfiniteScroll
)(LightTable);

const defaultLoadParams = {
    filters: { query: "" },
    sorting: USERS_DEFAULT_SORT,
    pagination: { pageNumber: 0, pageSize: USERS_PAGE_SIZE },
    reset: false
};

export default class UserAuditTable extends TableCoreComponent {
    static propTypes = {
        listItems: PropTypes.array
    };

    static defaultProps = {
        listItems: []
    };

    constructor(props) {
        super(props);

        this.defaultLoadParams = {
            filters:    {
                categoryIdFilter: "",
                query:            ""
            },
            sorting:    {
                direction: "asc",
                sortBy:    "username"
            },
            pagination: {
                pageNumber: 0,
                pageSize:   10
            },
            reset:      false
        };

        this.loadParams = this.defaultLoadParams;
        this.api = usersApi;
    }

    formatItem = (item) => {
        return {
            key:    item.id.toString(),
            name:   <TextCell>{item.username}</TextCell>,
            email:  <TextCell>{item.email}</TextCell>,
            status: <TextCell><ActiveLabel isActive={item.status} /></TextCell>,
            object: item
        }
    };

    headerItems = [
        {
            key:   "name",
            label: <FormattedMessage id='UserAudit_Download_UIText_tableHeaderElement.username' />
        },
        {
            key:   "email",
            label: <FormattedMessage id='UserAudit_Download_UIText_tableHeaderElement.email' />
        },
        {
            key:   "status",
            label: <FormattedMessage id='UserAudit_Download_UIText_tableHeaderElement.status' />
        }
    ];

    _manageApiCalls(loadParams) {
        return Promise.all([
            this._manageApiItemsCall(loadParams)
        ]).then(responses => this._insertItems(responses[0].totalCount, responses[0].users, this._isFiltered()))
    }

    _manageApiItemsCall(loadParams) {
        const { filters, sorting, reset } = { ...loadParams };

        return this.api.get(filters, sorting,
            { pageNumber: this.loadParams.pagination.pageNumber, pageSize: this.loadParams.pagination.pageSize })
            .then(response => {
                return {
                    totalCount: response.body.totalCount,
                    users:      response.body.users
                }
            })
    }

    _insertItems(count, items, isFiltered) {
        const listItems = (this.state.listItems || []).concat(items);
        if (isFiltered) {
            // also call count without filter to see the real total
            this._setCountAndItems(listItems, count, this.state.totalCount)
        } else {
            this._setCountAndItems(listItems, count, count)
        }

        return listItems;
    }

    loadItems(params, retry = false) {
        this.props.isLoadingHandler(true);
        return super.loadItems(params, retry).then(
            (response) => {
                this.props.isLoadingHandler(false);
                return response;
            }
        )
    }

    handleSelectionChange(selectedItems) {
        this.setState({ selectedItems });
        this.props.onUpdateSelection(selectedItems.map(item => item.object.id));
    };

    selectAllToggle() {
        if (this.state.selectedItems.length === this.state.totalCount) {
            this.setState({ selectedItems: [] });
            this.props.onUpdateSelection([]);
        } else {
            this.api.get(this.defaultLoadParams.filters, this.defaultLoadParams.sorting, { pageNumber: -1, pageSize: -1 }).then(items => {
                let itemsForSelection = items.body.users.map(item => this.formatItem(item));
                this.setState({ selectedItems: itemsForSelection});
                this.props.onUpdateSelection(itemsForSelection.map(item => item.object.id));
            })
        }
    }

    render = () => <div className="selectable-table">
        <Table {...this.getTableProps()}
               selectedItems={sortBy(this.state.selectedItems, item => item.object.username.toLowerCase())} />
        {this.state.activeModal && this.state.activeModal}
    </div>

}


// WEBPACK FOOTER //
// ./src/scripts/pages/AccountUsage/Components/UserAuditTable.jsx